module.exports = "img/flags/HN.bdbdaf8.png";